<div class="modal-header">
    <h2 class="modal-title">{{ azione }} documento</h2>
    <button class="close" type="button" aria-label="Chiudi" (click)="activeModal.close()" tabindex="0">
        <app-toolkit-bl-icon icon="close-big"></app-toolkit-bl-icon>
    </button>
</div>
<div class="modal-body">
    <form class="form" role="form" [formGroup]="criteriaForm">
        <div class="form-row">
            <div class="form-group col-md-4">
                <label for="idLegge">Classe documento*</label>
                <select class="form-control" formControlName="idClasseDocumento" id="idClasseDocumento">
                    <option [ngValue]="null">Seleziona un'opzione...</option>
                    <option *ngFor="let item of datalist.classeDocumento" [ngValue]="item.id">{{ item.descrizione }}</option>
                </select>
            </div>
            <div class="form-group col-md-4">
                <label for="didascalia">Didascalia*</label>
                <input class="form-control" id="didascalia" formControlName="didascalia" type="text">
            </div>
            <div class="form-group col-md-4">
                <label for="visibilita">Visibilità*</label>
                <div class="form-check form-check-inline">
                    <input name="docPublic" type="radio" id="visibilita_public" formControlName="docPublic" [value]="1">
                    <label for="visibilita_public">Pubblico</label>
                </div>
                <div class="form-check form-check-inline">
                    <input name="docPublic" type="radio" id="visibilita_pvt" formControlName="docPublic" [value]="0">
                    <label for="visibilita_pvt">Privato</label>
                </div>
            </div> 
            <div class="form-group col-md-12">
                <app-toolkit-upload-file
                    id="fileDocumentoOpera"
                    [fileName]="params ? params.nomeDocumento : undefined"
                    [disabled]="azione === 'Modifica'"
                    (completed)="setFile($event)"></app-toolkit-upload-file>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" tabindex="0" (click)="activeModal.close()" class="btn btn-outline-primary">Chiudi</button>
    <button [disabled]="criteriaForm.invalid || !file" type="button" tabindex="0" (click)="save()" class="btn btn-primary">Salva</button>
</div>